module.exports = __webpack_public_path__ + "img/107.3.aab70175.png";